import '../../styles/pages/search.scss';
import '../components/filters';

import generateTabs from '../components/generateTabs';

generateTabs('sidebar-last', { isLoadMore: false });